import React, { useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { AppStateContext } from '../AppStateContext';
import { Helmet } from "react-helmet";

// IMPORT COMPONENT
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Video from '../components/background/Video';

import { BsCheck } from 'react-icons/bs'

// IMPORT IMAGE
import YesimAlkanImage from '../media/yesimalkan-2.webp'
import HomeBanner2_1 from '../media/home-banner-2-1.png'
import HomeBanner2_2 from '../media/home-banner-2-2.png'
import HomeBanner2_3 from '../media/home-banner-2-3.png'

// IMPORT SLIDER
import TreatmentSlider from '../components/TreatmentSlider'
import TestimonalSlider from '../components/TestimonialSlider'
import ContactForm from '../components/ContactForm'

// IMPORT LOCAL ICONS
import Logo from '../media/logo512.png'
import banner7svg1 from '../media/banner7svg1.svg'
import banner7svg2 from '../media/banner7svg2.svg'
import banner7svg3 from '../media/banner7svg3.svg'
import dentalImplant from '../media/dental-implant.svg'
import dentalWhitening from '../media/dental-whitening.svg'
import dentalVeener from '../media/dental-veeners.svg'

import HomeVideo from '../media/dtyesimalkan-video.mp4'
import HomeVideo2 from '../media/dtyesimalkan-video-2.mp4'

// IMPORT BUTTONS
import WhatsApp from '../components/button/WhatsApp';
import PrimaryButton from '../components/button/PrimaryButton';
import SecondButton from '../components/button/SecondButton';

const Home = () => {

    // PAGE TITLE
    const pageTitle = 'Dt. Yeşim Alkan | Diş Tedavi'
    const metaDescription = 'Beyaz Dişler ve Sağlıklı Gülümseme için Diş Hekiminiz'

    const navigate = useNavigate();
    const { language, setLanguage } = useContext(AppStateContext);

    // STATE
    const hScreenHeight = window.innerHeight

    // REF
    const popularTreatments = useRef(null);
    const homeTreatments = useRef(null);

    // TEXT
    const translations = {
        tr: {
            HomeText1: 'Diş Estetiği',
            HomeText2: 'Beyaz Dişler ve Sağlıklı Gülümseme için Diş Hekiminiz',
            HomeText3: 'İyi diş hekimlerini ve klinikleri güzel gülüşler için bir araya getiriyoruz',
            HomeText4: "İstanbul'da en iyi diş tedavisi yöntemlerini ve diş hekimlerini bulabilirsiniz.",
            HomeText5: 'Tüm Hizmetler',
            bannerAboutText1: 'Dt. Yesim Alkan',
            bannerAboutText2: 'Diş sağlığınıza bizimle kavuşun!',
            bannerAboutText3: 'Deneyimli ve Profesyonel Hizmet. Yesim Alkan, yılların deneyimi ve uzmanlığı ile sizlere en iyi diş sağlığı hizmetini sunar. Her türlü diş sorununuzu çözmek ve sağlıklı bir gülümseme elde etmek için buradayız.',
            bannerAboutText4: 'Kişiye Özel Tedavi. Diş sağlığı herkes için farklıdır ve bireysel ihtiyaçlarınıza uygun çözümler sunmak bizim önceliğimizdir. Yesim Alkan, size özel bir tedavi planı oluşturarak, en iyi sonuçları elde etmenize yardımcı olur.',
            AboutText5: 'Hakkımda',
            banner1text6: 'Bizimle İletişime Geçin',
            banner2text1: 'Popüler Diş Tedavileri',
            banner2text2: 'Porselen Kuron',
            banner2text3: 'Daha Parlak Bir Gülümseme Elde Edin',
            banner2text4: 'Zirkonyum',
            banner2text5: 'Estetik Kronlarla Mükemmel Gülümseme',
            banner2text6: 'Diş İmplantları',
            banner2text7: 'İmplantlarla Kayıp Dişlerinizi Kazanın',
            banner2text8: 'Daha Fazla Bilgi',
            banner3text1: 'Neden Bizi Seçmelisiniz?',
            banner3text2: 'Hayal Ettiğiniz Gülüşe Bizimle Ulaşın',
            banner3text3: 'Kullanıcı Dostu Randevu Sistemi',
            banner3text4: 'En Deneyimli Diş Hekimleri',
            banner3text5: 'Uygun Fiyatlı Tedavi Seçenekleri',
            banner3text6: 'Gelişmiş Diş Klinikleri',
            banner3text7: 'İleri Teknolojik İşlemler',
            banner3text8: 'Kişiye Özel Diş Çözümleri',
            banner3text9: 'Güvenilir ve İlgili Diş Hekimleri',
            banner3text10: 'Memnun Hastaların Olumlu Yorumları',
            banner3text11: 'Operasyon İçin Teklif Alın',
            banner4text1: 'Diş Tedavileri',
            banner4text2: 'Daha Parlak Bir Gülümseme İçin Tedavi Çözümleri',
            banner4text3: 'Daha Fazla Bilgi İçin İletişime Geçin',
            banner5text1: 'Hastalarımız Ne Diyor?',
            banner5text2: "Yeşim Alkan Kliniği, dünya genelinden bireyleri en iyi diş hekimleri ve kapsamlı diş tedavi çözümleriyle buluşturmak amacıyla kurulmuştur. Temel hedefimiz, İstanbul'da benzersiz gereksinimlerinizi karşılayacak en avantajlı ve deneyimli diş tedavisi alternatiflerini keşfetme sürecini basitleştirmektir.",
            banner5text3: 'Deneyimli diş hekimlerinin uzmanlığında steril tedavi odalarında güvenli diş işlemleri gerçekleştiriyoruz. Değerli müşterilerimizden gelen olumlu geri bildirimler, bizi ileri taşıyan ilham kaynağımızdır. Onların Yeşim Alkan Kliniği aracılığıyla istedikleri diş estetik dönüşümlerini başarılı bir şekilde elde etmeleri, özverimizi artırıyor.',
            banner5text4: 'Bizimle İletişime Geçin',
            banner5text5: 'Videolar',
            banner6text1: 'Bize Ulaşın',
            banner6text2: 'Yeşim Alkan ile İstediğiniz Görünüme Sahip Olma Zamanı Yaklaşıyor.',
            banner6text3: 'Diş tedavisi düşünüyorsanız, istediğiniz sonuçlara ulaşmanıza yardımcı olmak için sizinle çalışmaktan onur duyarız.',
            banner6text4: 'Danışma randevusu ayarlamak ve sunduğumuz hizmetler hakkında daha fazla bilgi almak için hemen iletişime geçin.',
            banner6text5: "İstanbul'daki diş tedavisi operasyonlarımıza ilgi gösterdiğiniz için teşekkür ederiz.",
            banner6text6: 'Hastalarımıza diş tedavisinde en yüksek kalitede bakımı sunmaya adanmışız.',
            banner6text7: 'Her hastanın benzersiz olduğunu anlıyoruz ve istediğiniz sonuçlara ulaşmanıza yardımcı olmak için kişiselleştirilmiş tedavi planları sunmaya çalışıyoruz.',
            banner6text8: 'Diş tedavisi uzmanlarımızla danışma randevusu ayarlamak veya hizmetlerimizle ilgili sorularınız varsa, lütfen çekinmeden bizimle iletişime geçin.',
            banner6text9: 'Doktora Sor',
            banner7text1: 'Tedavi & Planlama',
            banner7text2: 'Form doldurarak veya iletişim bilgilerimizden bize ulaşabilir ve istediğiniz işlem hakkında bilgi alabilirsiniz',
            banner7text3: 'Tanışma & Bilgilendirme',
            banner7text4: 'Talebiniz doğrultusunda tedavilerimiz hakkında bilgilendirme yapıyor ve tedavi planlamasına yönlendiriyoruz.',
            banner7text5: 'Tedavinin Planlanması',
            banner7text6: 'Tedavinizi probleminize en uygun yöntem ile planlıyoruz ve tedavi sürecine başlıyoruz.',
            banner7text7: 'Tedavi Süreci',
            banner7text8: 'Tedaviniz sonlanana kadar tüm süreç boyunca gerekli kontrolleri ve bilgilendirmeleri yapıyoruz.'
        },
        en: {
            HomeText1: 'Dental Aesthetics',
            HomeText2: 'Beautify is our expertise, let us help you shine',
            HomeText3: 'We bring together good dentists and clinics for beautiful smiles',
            HomeText4: 'You can find the best dental treatment methods and dentists in Istanbul.',
            HomeText5: 'All Services',
            banner1text6: 'Contact Us',
            bannerAboutText1: "Dt. Yesim Alkan",
            bannerAboutText2: "Achieve Dental Health with Yesim Alkan!",
            bannerAboutText3: "Experienced and Professional Service: Yesim Alkan provides you with the best dental health service with years of experience and expertise. We are here to solve all your dental problems and help you achieve a healthy smile.",
            bannerAboutText4: "Personalized Treatment: Dental health is different for everyone, and providing solutions tailored to your individual needs is our priority. Yesim Alkan creates a customized treatment plan for you to achieve the best results.",
            banner2text1: 'Popular Dental Treatments',
            banner2text2: 'Teeth Whitening',
            banner2text3: 'Achieve a Brighter Smile',
            banner2text4: 'Dental Veneers',
            banner2text5: 'Flawless Smile with Aesthetic Veneers',
            banner2text6: 'Dental Implants',
            banner2text7: 'Reclaim Lost Teeth with Implants',
            banner2text8: 'More info',
            banner3text1: 'Why Choose Our Dental Clinic?',
            banner3text2: 'Achieve Your Desired Smile With Us',
            banner3text3: 'User-friendly Appointments',
            banner3text4: 'The Most Experienced Dentists',
            banner3text5: 'Affordable Treatment Options',
            banner3text6: 'State-of-the-art Dental Facilities',
            banner3text7: 'Advanced Technological Procedures',
            banner3text8: 'Personalized Dental Solutions',
            banner3text9: 'Trusted and Caring Dentists',
            banner3text10: 'Positive Reviews from Satisfied Patients',
            banner3text11: 'Get Offer For Operations',
            banner4text1: 'Dental Treatments',
            banner4text2: 'Dental Solutions For A Brighter Smile',
            banner4text3: 'Contact For More',
            banner5text1: 'What Our Patients Say?',
            banner5text2: "Yeşim Alkan Clinic has been established to connect individuals from all around the world with the finest dental practitioners and comprehensive dental treatment solutions. Our primary aim is to simplify the process of discovering the most advantageous and skilled dental treatment alternatives in Istanbul, tailored to address your unique requirements.",
            banner5text3: 'We execute secure dental procedures in sterile treatment rooms under the expertise of seasoned dentists. The encouraging feedback from our valued clientele serves as our driving inspiration. Their successful attainment of their desired dental transformations through Yeşim Alkan Clinic fuels our dedication."',
            banner5text4: 'Contact Us Now',
            banner5text5: 'Videos',
            banner6text1: 'Contact Us',
            banner6text2: "It's Almost Time To Have The Appearance You Want With Yeşim Alkan.",
            banner6text3: "If you're considering dental treatment, we would be honored to work with you to help you achieve your desired results.",
            banner6text4: 'Contact us now to schedule a consultation and learn more about the services we offer.',
            banner6text5: "Thank you for your interest in our dental treatment operations in Istanbul.",
            banner6text6: 'We are dedicated to providing our patients with the highest quality of care in dental treatments.',
            banner6text7: 'We understand that each patient is unique and we strive to provide personalized treatment plans to help you achieve your desired results.',
            banner6text8: 'If you would like to schedule a consultation with our dental treatment experts, or if you have any questions about our services, please do not hesitate to contact us.',
            banner6text9: 'Ask The Dentist',
            banner7text1: 'Treatment & Planning',
            banner7text2: 'You can reach us by filling out the form or using our contact information to inquire and get information about the treatment you want.',
            banner7text3: 'Introduction & Information',
            banner7text4: 'Based on your request, we provide information about our treatments and guide you through the treatment planning process.',
            banner7text5: 'Treatment Planning',
            banner7text6: 'We plan your treatment with the most suitable method for your problem and start the treatment process.',
            banner7text7: 'Treatment Process',
            banner7text8: 'Throughout the entire process until your treatment is completed, we perform the necessary checks and provide information.'
        },
        it: {
            banner1text1: 'Estetica Dentaler',
            banner1text2: 'Abbellire è la nostra specialità, lasciaci aiutarti a brillare',
            banner1text3: 'Uniamo buoni dentisti e cliniche per sorrisi bellissimi',
            banner1text4: 'Puoi trovare i migliori metodi di trattamento dentale e dentisti a Istanbul.',
            banner1text5: 'Tutti i Servizi',
            banner1text6: 'Contattaci',
            bannerAboutText1: "Dott. Yesim Alkan",
            bannerAboutText2: "Raggiungi la Salute Dentale con Yesim Alkan!",
            bannerAboutText3: "Servizio Esperto e Professionale: Yesim Alkan ti offre il miglior servizio di salute dentale con anni di esperienza e competenza. Siamo qui per risolvere tutti i tuoi problemi dentali e aiutarti a ottenere un sorriso sano.",
            bannerAboutText4: "Trattamento Personalizzato: La salute dentale è diversa per ognuno, e fornire soluzioni personalizzate alle tue esigenze individuali è la nostra priorità. Yesim Alkan crea un piano di trattamento personalizzato per aiutarti a ottenere i migliori risultati.",
            banner2text1: 'Trattamenti Dentali Popolari',
            banner2text2: 'Sbiancamento dei Denti',
            banner2text3: 'Ottieni un Sorriso Più Luminoso',
            banner2text4: 'Faccette Dentali',
            banner2text5: 'Sorriso Impeccabile con Rivestimenti Estetici',
            banner2text6: 'Impianti Dentali',
            banner2text7: 'Recupera i Denti Persi con gli Impianti',
            banner2text8: 'Maggiori informazioni',
            banner3text1: 'Perché Scegliere La Nostra Clinica Dentale?',
            banner3text2: 'Raggiungi Il Sorriso Dei Tuoi Sogni Con Noi',
            banner3text3: 'Prenotazioni Facili da Utilizzare',
            banner3text4: 'I Dentisti Più Esperti',
            banner3text5: 'Opzioni di Trattamento a Prezzi Accessibili',
            banner3text6: 'Strutture Odontoiatriche All\'Avanguardia',
            banner3text7: 'Procedure Tecnologiche Avanzate',
            banner3text8: 'Soluzioni Odontoiatriche Personalizzate',
            banner3text9: 'Dentisti Affidabili e Premurosi',
            banner3text10: 'Recensioni Positive da Pazienti Soddisfatti',
            banner3text11: "Ottieni un'offerta per interventi",
            banner4text1: 'Trattamenti Dentali',
            banner4text2: 'Soluzioni Dentali Per Un Sorriso Più Luminoso',
            banner4text3: 'Contattaci per maggiori informazioni',
            banner5text1: 'Cosa Dicono I Nostri Pazienti?',
            banner5text2: "La Clinica Yeşim Alkan è stata fondata con l'obiettivo di mettere in contatto persone provenienti da tutto il mondo con i migliori professionisti odontoiatri e soluzioni complete per trattamenti dentali. Il nostro obiettivo principale è semplificare il processo di scoperta delle opzioni di trattamento dentale più vantaggiose e competenti a Istanbul, personalizzate per rispondere alle tue esigenze uniche.",
            banner5text3: "Eseguiamo procedure odontoiatriche sicure in sale operatorie sterili sotto la guida di dentisti esperti. L'incoraggiante feedback dei nostri preziosi clienti è la nostra fonte d'ispirazione. Il loro raggiungimento di successo delle trasformazioni dentali desiderate tramite la Clinica Yeşim Alkan alimenta il nostro impegno.",
            banner5text4: 'Contattaci Ora',
            banner5text5: 'Video',
            banner6text1: 'Contattaci',
            banner6text2: "È quasi il momento di ottenere l'aspetto che desideri con Yeşim Alkan.",
            banner6text3: "Se stai considerando un trattamento dentale, saremmo onorati di lavorare con te per aiutarti a raggiungere i risultati desiderati.",
            banner6text4: 'Contattaci ora per prenotare una consulenza e saperne di più sui servizi che offriamo.',
            banner6text5: "Grazie per il tuo interesse nelle nostre operazioni di trattamento dentale a Istanbul.",
            banner6text6: 'Siamo dedicati a fornire ai nostri pazienti la massima qualità di cura nei trattamenti dentali.',
            banner6text7: 'Capiamo che ogni paziente è unico e ci sforziamo di fornire piani di trattamento personalizzati per aiutarti a raggiungere i risultati desiderati.',
            banner6text8: 'Se desideri prenotare una consulenza con i nostri esperti in trattamenti dentali o se hai domande sui nostri servizi, non esitare a contattarci.',
            banner6text9: 'Fai una Domanda al Dentista',
            banner7text1: 'Trattamento e Pianificazione',
            banner7text2: 'Puoi contattarci compilando il modulo o utilizzando le nostre informazioni di contatto per richiedere informazioni sulla procedura desiderata.',
            banner7text3: 'Presentazione e Informazioni',
            banner7text4: 'In base alla tua richiesta, forniamo informazioni sui nostri trattamenti e ti guidiamo attraverso il processo di pianificazione del trattamento.',
            banner7text5: 'Pianificazione del Trattamento',
            banner7text6: 'Pianifichiamo il tuo trattamento con il metodo più adatto al tuo problema e avviamo il processo di trattamento.',
            banner7text7: 'Processo di Trattamento',
            banner7text8: "Durante l'intero processo fino al completamento del trattamento, effettuiamo i controlli necessari e forniamo informazioni."

        },
    };

    // FUNCTIONS
    const getText = (key) => {
        return translations[language][key] // Default to the provided key if translation is not found
    }

    const handleNavigation = (path) => {
        window.scrollTo(0, 0)
        navigate(path)
    }

    const openLink = (url) => {
        window.open(
            url,
            '_blank'
        );
    }

    const scrollToRef = (ref) => {
        if (ref.current) {
            const navbarHeight = 80;
            const scrollToPosition = ref.current.offsetTop - navbarHeight;
            window.scrollTo({
                top: scrollToPosition,
                behavior: 'smooth',
            });
        }
    }

    return (
        <div className='w-full overflow-x-hidden bg-[#05161A]'>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
                <link rel="canonical" href="http://dtyesimalkan.com/" />
            </Helmet>
            <WhatsApp openLink={openLink} />
            <Navbar />
            {/* HOME */}
            <div className='relative' style={{ height: hScreenHeight }}>
                <Video hScreenHeight={hScreenHeight} HomeVideo={HomeVideo} />
                <div className='max-w-screen-xl h-full w-full m-auto pt-[80px] md:pt-[120px] z-30 flex flex-col justify-center relative'>
                    <div className='lg:w-2/3 w-full flex flex-col items-center'>
                        <div className='px-5 py-10 xl:p-10 z-30'>
                            <h2 className='text-xl md:text-2xl font-bold text-[#6DA5C0]'>{getText('HomeText1')}</h2>
                            <h1 className='text-4xl md:text-6xl pt-2 font-bold text-[#0F969C] custom-font'>{getText('HomeText2')}</h1>
                            <p className='md:text-lg pt-4 text-white'>{getText('HomeText3')}</p>
                            <p className='md:text-lg pt-2 text-white'>{getText('HomeText4')}</p>
                            <div className='flex flex-col md:flex-row gap-5 pt-8'>
                                <div onClick={() => scrollToRef(homeTreatments)}>
                                    <PrimaryButton className={'hidden md:block'} text={getText('HomeText5')} />
                                </div>
                                <div onClick={() => handleNavigation('/contact')}>
                                    <PrimaryButton className={'hidden md:block'} text={getText('banner1text6')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ABOUT */}
            <div className='relative pt-10 md:pt-20 md:pb-10'>
                <div className='relative max-w-screen-xl m-auto h-full w-full flex flex-col md:flex-row justify-center '>
                    <div className='w-1/2 m-auto lg:w-1/3 relative h-full '>
                        <img className='' src={YesimAlkanImage} alt='Dt-Yesim-Alkan'></img>
                    </div>
                    <div className='relative lg:w-2/3 h-full md:h-auto rounded-2xl flex items-center'>
                        <div className='absolute w-full h-full rounded-2xl z-30'></div>
                        <div className='px-5 py-10 xl:p-10 z-30 rounded-lg'>
                            <h1 className='text-xl md:text-2xl font-bold text-[#6DA5C0]'>{getText('bannerAboutText1')}</h1>
                            <h2 style={{ fontFamily: 'Righteous' }} className='text-2xl md:text-6xl pt-2 font-bold text-[#0F969C] custom-font-black'>{getText('bannerAboutText2')}</h2>
                            <p className='md:text-lg pt-8 text-slate-200'>{getText('bannerAboutText3')}</p>
                            <p className='md:text-lg pt-2 text-slate-200'>{getText('bannerAboutText4')}</p>
                            <div onClick={() => handleNavigation('/about')} className='md:flex pt-8'>
                                <SecondButton text={getText('bannerAboutText1')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* POPULAR TREATMENT */}
            <div ref={popularTreatments} className='max-w-screen-xl m-auto'>
                <div style={{ fontFamily: 'Righteous' }} className='text-2xl md:text-4xl text-start px-5 md:text-center text-[#0F969C] py-10 font-bold'>{getText('banner2text1')}</div>
                <div className='flex flex-col md:flex-row w-full justify-between gap-5'>
                    <div className='flex flex-col w-full relative h-56 md:h-72 rounded-none md:rounded-xl border-2 border-white/20'>
                        {/* <div className='absolute h-full w-full bg-white/50 rounded-none md:rounded-xl'></div>
                        <div className='absolute h-full w-full bg-[#0F969C] z-10 rounded-none md:rounded-xl'></div> */}
                        <img className='absolute right-0 h-full object-cover z-20 rounded-none md:rounded-xl' src={HomeBanner2_1} alt=''></img>
                        <div className='flex flex-col justify-between w-full h-full px-5 py-10 z-30 rounded-none md:rounded-xl'>
                            <div className='flex flex-row gap-5 items-center'>
                                <img src={dentalWhitening} className='w-8 h-8 md:w-12 md:h-12'></img>
                                <div className='text-md md:text-lg text-[#0F969C]'>{getText('banner2text2')}</div>
                            </div>

                            <div className='text-md md:text-xl text-[#6DA5C0] w-56'>{getText('banner2text3')}</div>
                            <div onClick={() => handleNavigation('/treatments')} className='flex'>
                                <SecondButton text={'More Info'} />
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col w-full relative h-56 md:h-72 rounded-none md:rounded-xl border-2 border-white/20'>
                        {/* <div className='absolute h-full w-full bg-white/50 rounded-none md:rounded-xl'></div>
                        <div className='absolute h-full w-full bg-[#0F969C] z-10 rounded-none md:rounded-xl'></div> */}
                        <img className='absolute h-full right-0 object-cover rounded-none md:rounded-xl z-20' src={HomeBanner2_2} alt=''></img>
                        <div className='flex flex-col justify-between w-full h-full px-5 py-10 rounded-none md:rounded-xl z-30'>
                            <div className='flex flex-row gap-5 items-center'>
                                <img src={dentalVeener} className='w-8 h-8 md:w-12 md:h-12'></img>
                                <div className='text-md md:text-lg text-[#0F969C]'>{getText('banner2text4')}</div>
                            </div>

                            <div className='text-md md:text-xl text-[#6DA5C0] w-60'>{getText('banner2text5')}</div>
                            <div onClick={() => handleNavigation('/treatments')} className='flex'>
                                <SecondButton text={'More Info'} />
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col w-full h-56 md:h-72 relative rounded-none md:rounded-xl border-2 border-white/20'>
                        {/* <div className='absolute h-full w-full bg-white/50 rounded-none md:rounded-xl'></div>
                        <div className='absolute h-full w-full bg-[#0F969C] z-10 rounded-none md:rounded-xl'></div> */}
                        <img className='absolute object-cover right-0 h-full rounded-none md:rounded-xl z-20' src={HomeBanner2_3} alt=''></img>
                        <div className='flex flex-col justify-between w-full h-full px-5 py-10 z-30'>
                            <div className='flex flex-row gap-5 items-center'>
                                <img src={dentalImplant} className='w-8 h-8 md:w-12 md:h-12'></img>
                                <div className='text-md md:text-lg text-[#0F969C]'>{getText('banner2text6')}</div>
                            </div>

                            <div className='text-md md:text-xl text-[#6DA5C0] w-56'>{getText('banner2text7')}</div>
                            <div onClick={() => handleNavigation('/treatments')} className='flex'>
                                <SecondButton text={'More Info'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* WHY */}
            <div className='w-full m-auto md:pt-20'>
                <div className='flex flex-col md:flex-row max-w-screen-xl m-auto gap-10'>
                    <div className='w-full md:w-2/3 flex flex-col md:flex-row  md:rounded-xl px-5 md:px-10 mt-10 md:m-auto '>
                        <div className='w-full h-full flex flex-col py-20 m-auto'>
                            <div className='text-[#6DA5C0] text-xl md:text-2xl'>{getText('banner3text1')}</div>
                            <div style={{ fontFamily: 'Righteous' }} className='text-2xl md:text-4xl md:w-96 pt-2 text-[#0F969C] font-bold'>{getText('banner3text2')}</div>
                            <div className='flex flex-col md:flex-row py-10 md:gap-5'>
                                <div className='flex flex-col gap-2 font-light text-white'>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text3')}</div>
                                    </div>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text4')}</div>
                                    </div>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text5')}</div>
                                    </div>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text6')}</div>
                                    </div>
                                </div>
                                <div className='flex flex-col gap-2 font-light text-white pt-2 md:pt-0'>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text7')}</div>
                                    </div>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text8')}</div>
                                    </div>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text9')}</div>
                                    </div>
                                    <div className='flex flex-row items-center gap-2'>
                                        <BsCheck className='text-[#0F969C]' size={30} />
                                        <div className='md:text-lg'>{getText('banner3text10')}</div>
                                    </div>
                                </div>
                            </div>
                            <div onClick={() => openLink('https://api.whatsapp.com/send?phone=905333536406')} className='flex md:pt-5'>
                                <SecondButton text={getText('banner3text11')} />
                            </div>
                        </div>
                    </div>
                    <div className='w-full md:w-1/3 h-full m-auto pt-10 md:pt-0'>
                        <img className='w-36 md:w-72 h-full object-contain m-auto' src={Logo} alt=''></img>
                    </div>
                </div>
            </div>
            {/* BANNER - IV */} {/* Dental Treatments*/}
            <div ref={homeTreatments} className='max-w-screen-xl w-full m-auto py-20 rounded-lg'>
                <div className='text-xl md:text-2xl font-bold text-[#6DA5C0] text-start md:text-center px-5'>{getText('banner4text1')}</div>
                <div style={{ fontFamily: 'Righteous' }} className='text-[#0F969C] text-start md:text-center text-2xl md:text-4xl pt-2 px-5 font-bold'>{getText('banner4text2')}</div>
                <div className=''>
                    <TreatmentSlider />
                </div>
            </div>
            {/* BANNER - VII - PLANNING */}
            <div className='max-w-screen-xl w-full m-auto flex flex-col md:flex-row md:mb-20'>
                <div className='w-full md:w-1/2 flex flex-col m-auto px-5 pb-10 md:p-0 '>
                    <div style={{ fontFamily: 'Righteous' }} className='text-2xl md:text-6xl text-[#0F969C] font-bold'>{getText('banner7text1')}</div>
                    <div className='text-md md:text-xl flex flex-col pt-4 md:font-bold md:w-96 text-[white]'>{getText('banner7text2')}</div>
                    <div className='pt-10 flex flex-col-reverse md:flex-row gap-5'>
                        <div onClick={() => handleNavigation('/treatments')} className='flex'>
                            <SecondButton text={getText('HomeText5')} />
                        </div>
                        <div onClick={() => handleNavigation('/contact')} className='flex'>
                            <SecondButton text={getText('banner4text3')} />
                        </div>
                    </div>
                </div>
                <div className='w-full md:w-1/2 flex flex-col bg-[#0F969C] px-5 md:px-20 py-10 md:py-20 lg:py-40 gap-10 md:gap-20 '>

                    <div className='flex flex-row-reverse gap-5'>
                        <img src={banner7svg1} className='w-10 h-10 md:w-12 md:h-12 m-auto'></img>
                        <div className='flex flex-col gap-2'>
                            <div className='text-white font-bold text-xl md:text-2xl'>{getText('banner7text3')}</div>
                            <div className='text-[#05161A] text-md md:text-xl font-bold'>{getText('banner7text4')}</div>
                        </div>
                    </div>

                    <div className='flex flex-row-reverse gap-5'>
                        <img src={banner7svg2} className='w-10 h-10 md:w-12 md:h-12 m-auto'></img>
                        <div className='flex flex-col gap-2'>
                            <div className='text-white font-bold text-xl md:text-2xl'>{getText('banner7text5')}</div>
                            <div className='text-[#05161A] text-md md:text-xl font-bold'>{getText('banner7text6')}</div>
                        </div>
                    </div>

                    <div className='flex flex-row-reverse gap-5'>
                        <img src={banner7svg3} className='w-10 h-10 md:w-12 md:h-12 m-auto'></img>
                        <div className='flex flex-col gap-2'>
                            <div className='text-white font-bold text-xl md:text-2xl'>{getText('banner7text7')}</div>
                            <div className='text-[#05161A] text-md md:text-xl font-bold'>{getText('banner7text8')}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-full h-full bg-white'>
                {/* BANNER - V */} {/* Testimonial Slider */}
                <div className='max-w-screen-xl w-full m-auto pt-10 md:pt-40 flex flex-col md:flex-row'>
                    <div className='w-full md:w-2/5 flex flex-col px-5'>
                        <div style={{ fontFamily: 'Righteous' }} className='text-2xl md:text-4xl pb-2 text-[#0F969C] text-start md:text-left'>{getText('banner5text1')}</div>
                        <div className='border-2 border-slate-200'></div>
                        <div className='pt-5 text-md md:text-lg'>{getText('banner5text2')}</div>
                        <div className='pt-5 text-md md:text-lg'>{getText('banner5text3')}</div>

                        <div onClick={() => handleNavigation('/contact')} className='pt-10 flex'>
                            <SecondButton text={getText('banner5text4')} />
                        </div>
                    </div>
                    <div className={`duration-500 w-full md:w-3/5 p-5`}>
                        <TestimonalSlider />
                    </div>
                </div>

                {/* BANNER - VI */} {/* Contact */}
                <div className='max-w-screen-xl w-full m-auto md:py-20 flex flex-col md:flex-row gap-10 '>

                    <div className='w-full md:w-1/2 flex flex-col px-5'>
                        <div className='text-[#6DA5C0] text-xl md:text-2xl'>{getText('banner6text1')}</div>
                        <div style={{ fontFamily: 'Righteous' }} className='text-2xl md:text-4xl pt-2 text-[#0F969C]'>{getText('banner6text2')}</div>
                        <div className='border-b-2 border-slate-200 pt-5'></div>
                        <div className='flex flex-col gap-5 md:gap-2 pt-5'>
                            <div className='flex flex-row items-center gap-2 '>
                                <BsCheck size={30} className=' shrink-0 text-[#0F969C]' />
                                <div className='md:text-lg text-black'>{getText('banner6text3')}</div>
                            </div>

                            <div className='flex flex-row items-center gap-2'>
                                <BsCheck size={30} className=' shrink-0 text-[#0F969C]' />
                                <div className='md:text-lg text-black'>{getText('banner6text3')}</div>
                            </div>

                            <div className='flex flex-row items-center gap-2'>
                                <BsCheck size={30} className=' shrink-0 text-[#0F969C]' />
                                <div className='md:text-lg text-black'>{getText('banner6text4')}</div>
                            </div>

                            <div className='flex flex-row items-center gap-2'>
                                <BsCheck size={30} className=' shrink-0 text-[#0F969C]' />
                                <div className='md:text-lg text-black'>{getText('banner6text5')}</div>
                            </div>
                            <div className='flex flex-row items-center gap-2'>
                                <BsCheck size={30} className=' shrink-0 text-[#0F969C]' />
                                <div className='md:text-lg text-black'>{getText('banner6text6')}</div>
                            </div>
                            <div className='flex flex-row items-center gap-2'>
                                <BsCheck size={30} className=' shrink-0 text-[#0F969C]' />
                                <div className='md:text-lg text-black'>{getText('banner6text7')}</div>
                            </div>
                        </div>
                        <div className='pt-5 italic'>{getText('banner6text8')}</div>
                        <div onClick={() => openLink('https://api.whatsapp.com/send?phone=905333536406')} className='pt-5'>
                            <SecondButton text={getText('banner6text9')} />
                        </div>
                    </div>
                    <div className='w-full md:w-1/2'>
                        <ContactForm />
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    )
}

export default Home